import React, {useEffect, useState} from "react";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import axios from "axios";
import {config} from "../../Helpers/env";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {dateStringConvert} from "../Utils/ConvertDate";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {useDebounce} from "../Lab/useDebounce";
import {PendingStatus, FinishedStatus} from "../DoctorsModule/doctorStyles";
import {Progress} from "../DoctorsModule/WaitingList";
import {ReusableRouteTabs} from "../Utils/Dialogs/ReusableTabs";
import {history} from "../../Helpers/history";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl.', hidden: false},
    {id: 'date', numeric: false, disablePadding: false, label: 'Booking Date', hidden: false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.', hidden: false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name', hidden: false},
    {id: 'status', numeric: false, disablePadding: false, label: 'Status', hidden: false},
    {id: 'emergency_reason', numeric: false, disablePadding: false, label: 'Reason for Emergency', hidden: false},
    {id: 'marked_at', numeric: false, disablePadding: false, label: 'Marked At', hidden: false},
    {id: 'action', numeric: false, disablePadding: true, label: 'Action', hidden: false},
];

const GynEmergencyAntenatal = ({actions, snackbars}) => {

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({emergencyList: [], loading: 'idle', total: 0});
    const [activePage, setActivePage] = useState(1);
    const [refreshKey, setRefreshKey] = useState(0);
    const [debouncedInputValue] = useDebounce(searchValue, 500);

    const {loading, total, emergencyList} = data;

    const components = [
        {label: 'Active Patients',     path: '/gyn-and-obs-waiting-list'},
        {label: 'Missed Appointments', path: '/gyn-missed-appointments'},
        {label: 'Delivered Mothers',   path: '/gyn-delivered-mothers'},
        // {label: 'High Risk Mothers',   path: '/gyn-high-risk-mothers'},
        {label: 'Emergency Patients',  path: '/gyn-emergency-patients', badge: true, badge_count: total},
    ];

    useEffect(() => {
        setData({...data, loading: 'pending'});
        axios.get(`${config.smsUrl}/obgyn/anc/booking/emergency_list/${activePage}`, {
            params: {search: debouncedInputValue, per_page: rowsPerPage}
        }).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = dt.bookings ? dt.bookings : [];
            const total_count = dt.total_count ? dt.total_count : 0;

            const status_labels = {
                2: <PendingStatus>Pending</PendingStatus>,
                3: <Progress>Treatment ongoing</Progress>,
                4: <FinishedStatus>Complete</FinishedStatus>
            };

            const items = arr.map((item, index) => {
                const baseAction = item.visit_status === 2 ? (
                    <button type='button' className='btn btn-sm small-btn sms-info-btn'
                        onClick={() => handleTakeUp(item.visit_id, item.patient_number)}>
                        Take up
                    </button>
                ) : item.visit_status === 3 ? (
                    <div style={{display: 'flex', gap: '6px'}}>
                        <button type='button' className='btn btn-sm small-btn sms-amber-btn'
                            onClick={() => history.push(`/gyn-and-obs-gynae-consultation/${item.patient_number}/${item.visit_id}/1`)}>
                            Continue
                        </button>
                        <button type='button' className='btn btn-sm small-btn sms-gray-btn'
                            onClick={() => handleEndVisit(item.visit_id)}>
                            End Visit
                        </button>
                    </div>
                ) : null;

                return {
                    ...item,
                    count: ((activePage - 1) * rowsPerPage) + index + 1,
                    date: item.booking_date ? dateStringConvert(item.booking_date) : '-',
                    patient_number: item.patient_number,
                    patient_name: `${!item.first_name ? "" : item.first_name} ${!item.last_name ? "" : item.last_name}`,
                    status: status_labels[item.visit_status] || null,
                    emergency_reason: item.emergency_reason || '-',
                    marked_at: item.emergency_marked_at ? dateStringConvert(item.emergency_marked_at) : '-',
                    action: (
                        <div style={{display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap'}}>
                            {baseAction}
                            <label style={{display: 'flex', alignItems: 'center', gap: '4px', margin: 0, cursor: 'pointer', fontSize: '13px'}}>
                                <input type='checkbox' checked={true} onChange={() => handleUnmarkEmergency(item)} />
                                Emergency
                            </label>
                        </div>
                    )
                };
            });
            setData({...data, loading: 'success', emergencyList: items, total: total_count});
        }).catch((err) => {
            setData({...data, loading: 'error'});
            logoutErrorMessage(err, null, actions);
        });
    }, [debouncedInputValue, activePage, rowsPerPage, refreshKey]);

    const handleEndVisit = (visit_id) => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        formData.append('action', 'end');
        axios.post(`${config.smsUrl}/cvisit/complete_visit`, formData).then(() => {
            actions.snackbarActions.snackSuccess('Visit ended successfully');
            setRefreshKey(prev => prev + 1);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const handleTakeUp = (visit_id, patient_number) => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        axios.post(`${config.smsUrl}/cvisit/Update_visit_takeup_status`, formData).then(() => {
            history.push(`/gyn-and-obs-gynae-consultation/${patient_number}/${visit_id}/1`);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const handleUnmarkEmergency = (item) => {
        axios.post(`${config.smsUrl}/obgyn/anc/booking/mark_emergency`, {
            id: item.id,
            is_emergency: false,
            emergency_reason: null,
            user_roles_id
        }).then(() => {
            actions.snackbarActions.snackSuccess('Emergency status removed');
            setRefreshKey(prev => prev + 1);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setActivePage(1);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const handleChangeNextPage = (value) => {
        setActivePage(value);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isRejected = loading === 'error';

    const {headCells, all_hidden, handleAllHeadCells, handleHeadCells} = useHiddenColumns(headData);

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div data-testid="gyn-emergency-patients" className='journals'>
            <PageTitle title='Emergency Antenatal Patients'/>
            <SubHeader title="Gyn and Obs" subTitle='Emergency Patients'>
                <div className="header-icon-margin-right-zero">
                    <img src="/images/antenatal-blue.png"
                         className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>
            <div className="mui-tables">
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <CustomTable title="Emergency Antenatal Patients" customPage
                             handleChangeNextPage={handleChangeNextPage}
                             headData={headCells} handler={handleSearch} records={10} total_count={total}
                             activePage={activePage} data={emergencyList} colSpan={5} term={searchValue}
                             handleHeadCells={handleHeadCells} all_hidden={all_hidden}
                             handleAllHeadCells={handleAllHeadCells} pagination={pagination}>
                    <TableBody>
                        {isLoading ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">
                                <img src="/images/smsloader.gif" alt="loader"/>
                            </TableCell>
                        </TableRow> : null}
                        {isSuccess ? emergencyList.length > 0 ? emergencyList.slice(0, rowsPerPage)
                            .map((item, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1}
                                          key={index} className='mui-table-row'>
                                    {headCells.map((head) => (
                                        <TableCell key={head.id}
                                                   hidden={head.hidden}>{item[head.id]}</TableCell>
                                    ))}
                                </TableRow>
                            )) : <TableRow>
                            <TableCell colSpan={headCells.length} align="center">No emergency patients found</TableCell>
                        </TableRow> : null}
                        {isRejected ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">The server did not return a
                                valid response</TableCell>
                        </TableRow> : null}
                    </TableBody>
                </CustomTable>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar};
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}};
}

export default connect(mapStateToProps, mapDispatchToProps)(GynEmergencyAntenatal);
